export const FirebaseConfig = {
  apiKey: "AIzaSyDzmOhBOH6jNEgTirebUUnuFP4qMAr24nQ",
  authDomain: "yaadi-95900.firebaseapp.com",
  databaseURL: "https://yaadi-95900.firebaseio.com",
  projectId: "yaadi-95900",
  storageBucket: "yaadi-95900.appspot.com",
  messagingSenderId: "648342874597",
  appId: "1:648342874597:web:a15d44cfa1c9186ced270c"
};

export const google_map_key = 'AIzaSyAaJDYWW7mrAns0pV4uVwEUsr3UlHPEqyU';
